import { useEffect, useState } from "react";
import { Flame, Star } from "lucide-react";
import { api } from "@/lib/api";

const CONF_LABEL = { Max: "BEST BET", High: "STRONG", Medium: "LEAN", Fair: "LEAN", Board: "TOP FAVORITE" };
const LEAGUES = ["NFL", "NBA", "NCAAF", "NCAAB", "NHL", "MLS", "MMA"];
const WEEKLY = ["NFL", "NCAAF"];

function PickRow({ p }) {
  const [open, setOpen] = useState(false);
  return (
    <button onClick={() => setOpen(!open)} className="w-full text-left py-2 border-b border-white/5 last:border-0" data-testid={`pick-${p.id}`}>
      <div className="flex items-center gap-3">
        <span className="w-8 h-8 rounded-full flex items-center justify-center text-[9px] font-black text-white shrink-0" style={{ backgroundColor: p.color }}>{p.pick_abbr}</span>
        <div className="min-w-0 flex-1">
          <div className="text-sm font-bold text-white line-clamp-2 break-words leading-tight">{p.label}</div>
          <div className="text-[11px] text-slate-400 truncate">vs {p.opponent}</div>
          <div className="text-[10px] text-slate-500 font-mono-num">{p.date}{p.time ? ` · ${p.time} ET` : ""}</div>
        </div>
        <div className="text-right shrink-0">
          {p.odds && <div className="font-mono-num font-bold text-emerald-400 text-sm">{p.odds}</div>}
          <div className="text-[9px] text-smasher-gold flex items-center gap-0.5 justify-end"><Star className="w-2.5 h-2.5 fill-smasher-gold" /> {CONF_LABEL[p.confidence] || "PICK"}</div>
        </div>
      </div>
      {open && p.summary && <p className="text-[11px] text-slate-400 mt-2 leading-relaxed" data-testid={`pick-summary-${p.id}`}>{p.summary}</p>}
    </button>
  );
}

export default function TopPicks() {
  const [league, setLeague] = useState("NFL");
  const [data, setData] = useState({});
  useEffect(() => {
    if (data[league]) return;
    api.get("/top-picks", { params: { league } })
      .then((r) => setData((d) => ({ ...d, [league]: r.data.picks || [] })))
      .catch(() => setData((d) => ({ ...d, [league]: [] })));
  }, [league, data]);
  const picks = data[league];
  return (
    <div className="panel p-4" data-testid="top-picks">
      <div className="flex items-center gap-2 font-heading font-bold tracking-wide text-smasher-gold mb-2"><Flame className="w-4 h-4" /> TODAY'S FREE PICKS</div>
      <div className="flex flex-wrap gap-1 mb-3">
        {LEAGUES.map((l) => (
          <button key={l} onClick={() => setLeague(l)} className={`px-2 py-1 rounded-md text-[9px] font-black transition-colors ${league === l ? "btn-gold" : "bg-white/5 text-slate-400 hover:text-smasher-gold"}`} data-testid={`picks-tab-${l.toLowerCase()}`}>{l}</button>
        ))}
      </div>
      <div className="space-y-1">
        {!picks && <p className="text-xs text-slate-500 py-3">Loading…</p>}
        {picks?.map((p) => <PickRow key={p.id} p={p} />)}
        {picks && !picks.length && <p className="text-xs text-slate-500 py-3" data-testid="top-picks-empty">No {league} picks right now — new picks post every morning.</p>}
      </div>
      <div className="text-[10px] text-slate-600 mt-2" data-testid="top-picks-cadence">
        Hand-picked by the Sportsbook Smasher team · {league} picks refresh {WEEKLY.includes(league) ? "weekly" : "daily"} · tap a pick for the breakdown
      </div>
    </div>
  );
}
